"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.Loadout = void 0;
const jsx_runtime_1 = require("react/jsx-runtime");
const Dropdown_1 = require("./Dropdown");
const equipmentSlotCoordinates = [
    { key: "helmet", label: "Helmet", left: 84, top: 11 },
    { key: "cape", label: "Cape", left: 43, top: 50 },
    { key: "necklace", label: "Neck", left: 84, top: 50 },
    { key: "ammo", label: "Ammo", left: 124, top: 50 },
    { key: "weapon", label: "Weapon", left: 28, top: 89 },
    { key: "chest", label: "Chest", left: 84, top: 89 },
    { key: "offhand", label: "Offhand", left: 140, top: 89 },
    { key: "legs", label: "Legs", left: 84, top: 129 },
    { key: "gloves", label: "Gloves", left: 28, top: 169 },
    { key: "feet", label: "Feet", left: 84, top: 169 },
    { key: "ring", label: "Ring", left: 140, top: 169 },
];
const slotSize = 60;
const referenceSlotSize = 36;
const equipmentAnchor = equipmentSlotCoordinates[0];
const scaledEquipmentSlots = equipmentSlotCoordinates.map((slot) => ({
    ...slot,
    left: equipmentAnchor.left + ((slot.left - equipmentAnchor.left) * slotSize) / referenceSlotSize,
    top: equipmentAnchor.top + ((slot.top - equipmentAnchor.top) * slotSize) / referenceSlotSize,
}));
const equipmentLeft = Math.min(...scaledEquipmentSlots.map((slot) => slot.left));
const equipmentTop = Math.min(...scaledEquipmentSlots.map((slot) => slot.top));
const equipmentSlots = scaledEquipmentSlots.map((slot) => ({
    ...slot,
    left: slot.left - equipmentLeft,
    top: slot.top - equipmentTop,
}));
const equipmentWidth = Math.max(...equipmentSlots.map((slot) => slot.left + slotSize));
const equipmentHeight = Math.max(...equipmentSlots.map((slot) => slot.top + slotSize));
// We currently do not have empty models for these slots, so prevent naked characters for now.
const equipmentSlotsRequiringItems = new Set([
    "helmet",
    "chest",
    "legs",
    "gloves",
    "feet",
]);
const slotStyle = {
    alignItems: "center",
    backgroundColor: "#111",
    border: "1px solid #8f8f8f",
    boxSizing: "border-box",
    color: "#ffffff",
    display: "flex",
    fontSize: 12,
    justifyContent: "center",
    position: "relative",
    textAlign: "center",
};
function ItemSlot({ itemId, allowEmpty, onItemSelect, registry, substituteItemIds, }) {
    const item = itemId === null ? undefined : registry === null || registry === void 0 ? void 0 : registry.get(itemId);
    const trigger = item ? ((0, jsx_runtime_1.jsx)("img", { src: item.inventoryImage, alt: item.itemName, title: `${item.itemName} (${itemId})`, style: { maxHeight: "90%", maxWidth: "90%", imageRendering: "pixelated" } })) : ((0, jsx_runtime_1.jsx)("span", { children: itemId !== null && itemId !== void 0 ? itemId : "-" }));
    if (substituteItemIds.length === 0)
        return trigger;
    return ((0, jsx_runtime_1.jsxs)(Dropdown_1.Dropdown, { menuStyle: {
            display: "grid",
            gridTemplateColumns: "24px 1fr",
            width: slotSize * 2,
        }, trigger: trigger, children: [allowEmpty && ((0, jsx_runtime_1.jsxs)("div", { onClick: () => onItemSelect(null), style: {
                    alignItems: "center",
                    cursor: "pointer",
                    display: "grid",
                    gridColumn: "1 / -1",
                    gridTemplateColumns: "24px 1fr",
                    height: "32px",
                }, children: [(0, jsx_runtime_1.jsx)("span", {}), (0, jsx_runtime_1.jsx)("span", { children: "Empty" })] })), substituteItemIds.map((substituteId) => {
                const substitute = registry === null || registry === void 0 ? void 0 : registry.get(substituteId);
                if (!substitute)
                    return null;
                return ((0, jsx_runtime_1.jsxs)("div", { onClick: () => onItemSelect(substituteId), title: `${substitute.itemName} (${substitute.cacheItemId})`, style: {
                        alignItems: "center",
                        justifyItems: "center",
                        cursor: "pointer",
                        display: "grid",
                        gap: 4,
                        gridColumn: "1 / -1",
                        gridTemplateColumns: "24px 1fr",
                        height: "32px",
                    }, children: [(0, jsx_runtime_1.jsx)("img", { src: substitute.inventoryImage, alt: substitute.itemName, style: { maxHeight: "24px", imageRendering: "pixelated" } }), (0, jsx_runtime_1.jsx)("span", { children: substitute.itemName })] }, substituteId));
            })] }));
}
function Loadout({ loadout, onItemSelect, registry, getSubstitutes }) {
    return ((0, jsx_runtime_1.jsxs)("div", { style: { display: "flex", gap: 24 }, children: [(0, jsx_runtime_1.jsxs)("section", { children: [(0, jsx_runtime_1.jsx)("h3", { children: "Equipment" }), (0, jsx_runtime_1.jsx)("div", { style: { height: equipmentHeight, position: "relative", width: equipmentWidth }, children: equipmentSlots.map((slot) => ((0, jsx_runtime_1.jsx)("div", { style: {
                                ...slotStyle,
                                height: slotSize,
                                left: slot.left,
                                position: "absolute",
                                top: slot.top,
                                width: slotSize,
                            }, children: (0, jsx_runtime_1.jsx)(ItemSlot, { allowEmpty: !equipmentSlotsRequiringItems.has(slot.key), itemId: loadout.equipment[slot.key], onItemSelect: (itemId) => onItemSelect({ kind: "equipment", slot: slot.key }, itemId), registry: registry, substituteItemIds: getSubstitutes(slot.key, registry) }) }, slot.key))) })] }), (0, jsx_runtime_1.jsxs)("section", { children: [(0, jsx_runtime_1.jsx)("h3", { children: "Inventory" }), (0, jsx_runtime_1.jsx)("div", { style: { display: "grid", gap: 4, gridTemplateColumns: `repeat(4, ${slotSize}px)` }, children: loadout.inventory.map((itemId, index) => ((0, jsx_runtime_1.jsx)("div", { style: { ...slotStyle, height: slotSize, width: slotSize }, children: (0, jsx_runtime_1.jsx)(ItemSlot, { allowEmpty: true, itemId: itemId, onItemSelect: (selectedItemId) => onItemSelect({ index, kind: "inventory" }, selectedItemId), registry: registry, substituteItemIds: getSubstitutes(null, registry) }) }, index))) })] })] }));
}
exports.Loadout = Loadout;
